import apiPosition from '@/api/position'
export default [
  {
    path: '/positions',
    name: 'position',
    meta: { requiresAuth: true },
    component: () => import('@/pages/position/index.vue')
  },
  {
    path: '/positions/:id',
    name: 'position-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/position/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiPosition.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
